module.exports = __webpack_public_path__ + "img/indicator4_gray_v2.46dff4d1.svg";